import { render, staticRenderFns } from "./ExpiredSignup.vue?vue&type=template&id=5f4f4025&scoped=true&"
import script from "./ExpiredSignup.vue?vue&type=script&lang=js&"
export * from "./ExpiredSignup.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredSignup.vue?vue&type=style&index=0&id=5f4f4025&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f4025",
  null
  
)

export default component.exports